/**
 * 组件的emit事件声明
 * 基于方案设计文档生成
 */
export const emits = [
  /** visible 变化时触发（用于 v-model） */
  'update:visible',
  /** 弹窗关闭时触发 */
  'close',
  /** 弹窗打开时触发 */
  'open',
  /** 弹窗完全打开后触发（动画结束） */
  'opened',
  /** 弹窗完全关闭后触发（动画结束） */
  'closed',
  /** 点击遮罩层时触发 */
  'clickOverlay',
  /** 按钮点击时触发（仅 actions 配置生效） */
  'action-click',
];

